import x from "./Reviews";
export default x;
